import { api } from '../lib/api';

export interface PublicFormQuestion {
  id: string;
  label: string;
  type: 'text' | 'single' | 'multiple';
  required: boolean;
  options?: string[];
}

export interface PublicFormStep {
  id: string;
  title: string;
  content: string;
  questions: PublicFormQuestion[];
}

export interface PublicFormData {
  id: string;
  name: string;
  description: string;
  token: string;
  pages: PublicFormStep[];
  theme?: Record<string, any>;
}

export const publicFormApi = {
  getByToken: async (token: string): Promise<PublicFormData> => {
    const response = await api.get(`/public/forms/${token}`);
    return response.data;
  },

  submit: async (token: string, answers: Record<string, any>, forceComplete = true) => {
    const response = await api.post(`/public/forms/${token}/submissions`, {
      answers,
      forceComplete,
    });
    return response.data;
  },
};
